import { useInViewAnimation } from '~/hooks/useInViewAnimation';
import SetupDemoVideo from '../../assets/videos/SetupDemo.mp4';
import ProjectOverviewDemoVideo from '../../assets/videos/ProjectOverviewDemo.mp4';
import ExportDemoVideo from '../../assets/videos/ExportDemo.mp4';
import VideoAnalysisDemoVideo from '../../assets/videos/VideoAnalysisDemo.mp4';
import { useEffect, useRef, useState } from 'react';

const FeaturesSection = () => {
  const { ref: containerRef, inView: containerInView } = useInViewAnimation({
    threshold: 0.1,
  });
  const { ref: listRef, inView: listInView } = useInViewAnimation({
    threshold: 0.2,
  });
  const { ref: videoContainerRef, inView: videoContainerInView } =
    useInViewAnimation({ threshold: 0.2 });

  const featureOptions = [
    {
      id: 1,
      title: 'Easy Setup',
      description: 'Create Projects and upload your data without hassle.',
      videoSrc: SetupDemoVideo,
    },
    {
      id: 2,
      title: 'High Level Overview',
      description:
        'Understand the big picture of your data quickly and efficiently.',
      videoSrc: ProjectOverviewDemoVideo,
    },
    {
      id: 3,
      title: 'Data Drilldown',
      description: 'Dive deep into specific data points for detailed insights.',
      videoSrc: VideoAnalysisDemoVideo,
    },
    {
      id: 4,
      title: 'Data in your hands',
      description: 'Access and analyze your data anytime, anywhere.',
      videoSrc: ExportDemoVideo,
    },
  ];
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  const currentOption = featureOptions[activeIndex];

  const handleOptionClick = (index: number) => {
    setActiveIndex(index);
  };
  // Remove autoplay logic. Only play when user interacts.

  const handleVideoEnded = () => {
    const nextIndex = (activeIndex + 1) % featureOptions.length;
    setActiveIndex(nextIndex);
  };

  return (
    <div
      ref={containerRef}
      className={`features-section-container ${containerInView ? 'is-in-view' : ''}`}
    >
      <div
        ref={listRef}
        className={`features-list animate-slide-left ${listInView ? 'is-in-view' : ''}`}
      >
        {featureOptions.map((option, index: number) => (
          <div
            key={option.id}
            className={`feature-option ${index === activeIndex ? 'active' : ''}`}
            onClick={() => handleOptionClick(index)}
          >
            <h3 className="option-title">{option.title}</h3>
            <p className="option-description">
              <span className="bullet-point">•</span> {option.description}
            </p>
          </div>
        ))}
      </div>

      <div
        ref={videoContainerRef}
        className={`video-player-container animate-slide-right ${videoContainerInView ? 'is-in-view' : ''}`}
      >
        {currentOption && (
          <video
            ref={videoRef}
            key={currentOption.id}
            className="feature-video"
            controls
            onEnded={handleVideoEnded}
          >
            <source src={currentOption.videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  );
};

export default FeaturesSection;
